import { locale } from '@/utils/locale';

export const trialActive = {
  title: locale('bannerTitanTrialInSites.title'),
  description: locale('bannerTitanTrialInSites.description'),
  tagOfTrialTime: locale('bannerTitanTrialInSites.tagOfTrialTime'),

};
